import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6204b5bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert-overlay" }

import { translate } from "@/util/intl";


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertOverlay',
  props: ['title', 'text'],
  emits: ['close'],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(__props.title), 1),
    _createElementVNode("p", null, _toDisplayString(__props.text), 1),
    _createElementVNode("button", {
      class: "buttonContinue",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('close')), ["enter"]))
    }, _toDisplayString(_unref(translate)("generic-close")), 33)
  ]))
}
}

})